import { useSyncExternalStore } from 'react';
import { PITCH_ORDER, type BaseballState, type PitchType } from '@shared/types';

/** Señas del receptor (sugerencia de tipo y zona al lanzador humano). Ajustes; activadas por defecto. */
const KEY = 'sportsarena.catcherSigns';
let on = (() => {
  try {
    return typeof window === 'undefined' || localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
})();
const listeners = new Set<() => void>();
export const getCatcherSigns = (): boolean => on;
export const setCatcherSigns = (v: boolean): void => {
  on = v;
  try {
    localStorage.setItem(KEY, v ? '1' : '0');
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};
export const useCatcherSigns = (): boolean =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getCatcherSigns,
    getCatcherSigns
  );

/** Dedos de la seña: 1 recta, 2 curva, 3 slider, 4 cambio, 5 sinker. */
export const signFingers = (type: PitchType): number => PITCH_ORDER.indexOf(type) + 1;

/** Seña que ve el lanzador local (antes de lanzar), o null si no hay o están desactivadas. */
export const localSign = (bb: BaseballState | null | undefined, localPlayerId: string | null, enabled: boolean): { type: PitchType; zone: number } | null =>
  enabled && bb?.sign && bb.pitcherId === localPlayerId && (bb.phase === 'ready' || bb.phase === 'windup') ? bb.sign : null;
